import React, { Component } from 'react'
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import './Login.css'


import {GetUserLogin, Alerts} from '../../helpers'


function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center" >
            {'Copyright © '}
            <Link color="inherit" href="https://backend.goodluckworld.club/login">
                Wishours greetings
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            isLoading: false,
        }
    }

    handleUsernameChange = (e) => {
        this.setState({
            username: e.target.value
        });
    }

    handlePasswordChange = (e) => {
        this.setState({
            password: e.target.value
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({
            isLoading: true
        });
        const { username, password } = this.state;
        if (username === '' && password === '') {
            Alerts.alertMessage("Please enter your email and password.", "Input Error !", "danger");
        }else if(username === ''){
            Alerts.alertMessage("Please enter your email.", "Input Error !", "danger");
        }else if(password === ''){
            Alerts.alertMessage("Please enter your password", "Input Error !", "danger");
        }else{
            const data = {
                email:this.state.username,
                password:this.state.password
            }
            let resp = await GetUserLogin.getUserLogin(data);
            if (resp) {
              
               const roles = resp.userData.roles;
               let isadmin = roles.find(o => o === "ROLE_SUPER_ADMIN");
               if(isadmin !== undefined){
                   this.persistUserDetails(resp);
               }else{
                this.setState({
                    isLoading: false
                });
                Alerts.alertMessage("Invalid email or password! ", "Sorry !", "danger");
            }
            }else{
                this.setState({
                    isLoading: false
                });
            }
        }
       
       

    }

    persistUserDetails = (data) => {
        sessionStorage.setItem('isAuthenticated', 'true');
        sessionStorage.setItem('userData', JSON.stringify(data.userData));
        sessionStorage.setItem('userToken', data.accessToken);
        this.isLoggedIn();
    };
    isLoggedIn = () => {
        let isAuthenticated = sessionStorage.getItem('isAuthenticated');
        if (isAuthenticated && isAuthenticated === 'true') {
            let from = '/';
            if (this.props.location.state) {
                from = this.props.location.state.pre_path;
            }
            this.setState({
                isLoading: false
            });
            setTimeout(function () {
                window.location.href = from; 
            }, 2000); //will call the function after 2 secs.

        }

    };
    render() {
        const isAuthenticated = sessionStorage.getItem('isAuthenticated');
        if (isAuthenticated && isAuthenticated === 'true') {
            this.props.history.push('/');
        }
        const { isLoading } = this.state;
        return (
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className="auth-wrapper">
                <div className="paper">
                    <Avatar className="avatar">
                        <LockOutlinedIcon />
                    </Avatar>
                    {/* <Typography component="h1" variant="h5">
                       Wishours Greetings
                    </Typography> */}
                    <div className='brand-img'>
                        <img src={process.env.PUBLIC_URL + '/logo.png'} alt="logo"/>
                    </div>
                    <form className="form" onSubmit={this.handleSubmit} noValidate>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Username"
                            name="email"
                            autoComplete="email"
                            size="small"
                            autoFocus
                            value={this.state.username}
                            onChange={this.handleUsernameChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            size="small"
                            value={this.state.password}
                            onChange={this.handlePasswordChange}
                        />
                        {/* <FormControlLabel
                            control={<Checkbox value="remember" color="primary" />}
                            label="Remember me"
                            className="mg15"
                        /> */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className="submit"
                        >
                           {isLoading ? 'Please wait..' : ' Sign In'}
                        </Button>

                    </form>

                    <Box mt={4}>
                    <Copyright />
                </Box>
                </div>
               
                </div>
     
               
            </Container>
        )

    }
}

export default Login;